import { isBrowser } from "../../../utils";
import {
  ACTIVE_MERCHANT_ID,
  AUTH_MODE,
  CURRENT_USER,
  OKTA_TOKEN,
  TOKEN,
  PAGE,
} from "../constants";
import { clearTokenManager } from "./oktaAuth";

const resetAuth = () => {
  if (isBrowser()) {
    window.localStorage.removeItem(OKTA_TOKEN);
    window.localStorage.removeItem(AUTH_MODE);
    window.localStorage.removeItem(TOKEN);
    window.localStorage.removeItem(CURRENT_USER);
    window.localStorage.removeItem(PAGE);

    // Merchant auth is stored in sessionStorage (see storage.js); clear it too.
    window.sessionStorage.removeItem(OKTA_TOKEN);
    window.sessionStorage.removeItem(CURRENT_USER);
    window.sessionStorage.removeItem(ACTIVE_MERCHANT_ID);
  }

  clearTokenManager();
};

export default resetAuth;